import { filter, Location } from "@/model/master/Location";
import { getField, updateField } from 'vuex-map-fields';

 
const state = {
    rows: [],
    entity: Location,
    filter: filter,
    baseModuleUrl : process.env.VUE_APP_MASTER_API_URL + "master-service/master"
};
//TODO find a better way to cleanup the filter
//const filterDefault = Object.assign({}, filter);
const filterDefault = JSON.parse(JSON.stringify(filter));

const getters = {
    getField
};

const actions = {
    generateReport(context, parameter){
        var idReport = parameter.idReport ? parameter.idReport : 1
        var fileName = parameter.fileName ? parameter.fileName : "LocationReport"
        var filter = parameter.filter ? parameter.filter : context.state.filter
        var cloneFilter = Object.assign({}, filter)
        //removing empty fileds
        for(var key in cloneFilter)
          if(cloneFilter.hasOwnProperty(key) && cloneFilter[key] == "") delete cloneFilter[key]

        var filterReport = {
            idReport: idReport,
            reportType: parameter.reportType,
            fileName: fileName,
            jsonDataFilter: JSON.stringify(cloneFilter)
        };

        // we will need a proxy in production
        filterReport.proxyDownloadUrl = process.env.VUE_APP_ADM_API_URL+"report-service";

        var urlRep = process.env.VUE_APP_REPORT_API_URL + "report-service/mmf/report/dispatcher/";        
        if( parameter.type == 'synchronous' ){
            context.dispatch("api/postReportDownload", {
                url: urlRep + parameter.type, 
                data: filterReport
              }, {root: true})
              .then(data => {
                  
                  if( !data || data.size == 0 ){
                    context.dispatch("base/showDanger", {
                        userAlertDangerStr: "No report with this fields",
                        userAlertDangerVisible: false,
                        }, {root: true})
                    return;
                  }
    
                var blob=new Blob([data]);
                var link=document.createElement('a');
                link.style.display = 'none'
                link.href=window.URL.createObjectURL(blob);
                link.download="LocationReport-" + (new Date().getTime()) +"."+ parameter.reportType.toLowerCase();
                link.click();
                link.remove();
              });
        }else{
            context.dispatch("api/post", {
                url: urlRep + parameter.type, 
                data: filterReport,
              }, {root: true})
              .then(response => {
                    if( response.status == 200){
                        context.dispatch("base/showSuccess", {
                            userAlertSuccessStr: "Your report has been scheduled.",
                            dismissCountDown: 5,
                            userAlertSuccessVisible: false,
                            }, {root: true})

                    }
                    else{
                        context.dispatch("base/showDanger", {
                            userAlertDangerStr: "A problem occurred while scheduling your report, check with your system administrator.",
                            userAlertDangerVisible: false,
                            }, {root: true})
                    }
              });
        }
    }
};
const mutations = {
    updateField,
    setRows(state, rows) {
        state.rows = rows;
    },
    setEntity(state, entity) {
        state.entity = entity;
    },
    setClearFilter(state) {
        //TODO find a better way to cleanup the filter
        state.filter = filterDefault;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};